export const appointmentMetaFields = [
    {
        name: `Doctor`,
        field: `doctor`,
        check: `required`,
    },
    {
        name: `Clinic`,
        field: `clinic`,
        check: `required`,
    },
    {
        name: `Date`,
        field: `appointmentDate`,
        check: `required`,
    },
    {
        name: `Time`,
        field: `time`,
        check: `required`,
    },
];

export const reminderMetaFields = [
    {
        name: `Date`,
        field: `date`,
        check: `required`,
    },
    {
        name: `Time`,
        field: `time`,
        check: `required`,
    },
];
export const consultationReqMetaFields = [
    {
        name: `Clinic`,
        field: `clinic`,
        check: `required`,
    },
    {
        name: `Physician`,
        field: `physician`,
        check: `required`,
    },
];
